import React from 'react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import {EditorDialog} from '../editor-components';

/** @class FundrasingLinksButton
  * A component that provides a button that,
  * when clicked, displays a modal list of
  * booths associated with an exhibitor.
  * @param {object} booths - the booths to display,
  * as a map of expoID -> showID -> boothID -> booth name
  */
export default class FundrasingLinksButton extends ReactFireComponent {
  /** @constructor
    * Constructs a new intance of FundrasingLinksButton.
    */
  constructor(props) {
    super(props);
    this.state = {showDialog: false, expos: {}}
  }
  componentWillMount() {
    this.bindAsObject('/expos', 'expos');
  }
  componentWillUnmount() {
    this.unbind('expos');
  }
  /** @render
    * Renders the component
    */
  render() {
    // Don't show a button if there are no expos
    if(!this.state.expos || this.state.expos.length === 0) return '';
    // Reorganize the tree structure of expos into an array
    var data = [];
    Object.keys(this.state.expos).forEach((expoID) => {
      Object.keys(this.state.expos[expoID].shows).forEach((showID) => {
        if(this.state.expos[expoID].shows[showID].metadata.isSample) return;
        const host = this.state.expos[expoID].metadata.host;
        data.push({
          expoID: expoID,
          showID: showID,
          link: `https://${host}/${showID}/#/fundraising/${this.props.token}`
        });
      });
    });
    var columns = [
      {Header: 'Expo', accessor: 'expoID'},
      {Header: 'Show', accessor: 'showID'},
      {Header: 'Link', accessor: 'link', Cell: (row) => (
        <a href={row.value}>{row.value}</a>
      )}
    ];
    return (
      <div>
        <EditorDialog show={this.state.showDialog} onExit={() => this.setState({showDialog: false})}>
          <ReactTable filterable data={data} columns={columns} style={{minWidth: "700px"}}/>
        </EditorDialog>
        <button className="btn btn-info" onClick={()=>this.setState({showDialog: true})}>
          <FontAwesome name="dollar-sign"/> Fundraising Links
        </button>
      </div>
    )
  }
}

FundrasingLinksButton.propTypes = {
  booths: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/affiliate-list/fundraising-links-button.js